import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';
import { HttpClient, HttpHeaders, HttpBackend  } from '@angular/common/http';
import { Observable } from 'rxjs';

import 'rxjs/add/operator/toPromise';

import * as ent from '../entities/index'
import * as filters from '../filters/index'
import * as serv from '../services/index'

//constants
import {Constants} from '../constants/Constants'

import { ConfigService }         from '../services/Config.service';

@Injectable()
export class AuthenticationService {

  private authenticateUserUrl = '';
  private tokenUrl = '';
  public currentUser = '';
  appConfig: ent.AppConfig;

  constructor(private http: Http, private httpClient: HttpClient, handler: HttpBackend, private httpClientSkipIntercept: HttpClient, private configService: ConfigService) {
      this.authenticateUserUrl = configService.appConfig.UrlBase + '/Authentication/AuthenticateUser';
      this.tokenUrl = configService.appConfig.UrlBase.replace('/api','') + '/token';

      this.httpClientSkipIntercept = new HttpClient(handler);
  }

  getAccessToken(): any {
    let item = localStorage.getItem('accessToken');
    return item;
  }

  logout(): any {
    localStorage.removeItem('accessToken');
  }

  authenticateUser(): Observable<ent.AuthenticationResult> {
    return this.httpClient.get<ent.AuthenticationResult>(this.authenticateUserUrl);
  }

  checkLoginStatus(): boolean {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser){
        return true;
    }
    else {
        return false;
    }
  }

  getUserInfo(): ent.UserInfo {
        
        var userInfo: ent.UserInfo = {SalesOffice: new ent.SalesOffice(), Employee: new ent.Employee(), Features: [], AppSettings: []};
        
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser)
        {
            
            let salesOffice: ent.SalesOffice = currentUser.salesOffice;
            let employee: ent.Employee = currentUser.employee;
            let features: ent.Feature[] = currentUser.features;
            let appSettings: ent.AppSetting[] = currentUser.appSettings;
            
            userInfo = {SalesOffice: salesOffice, Employee: employee, Features: features, AppSettings: appSettings} ;
            
        }
        return userInfo;

    }
  
  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}